<res-patent-documentation-link></res-patent-documentation-link>
<div>
	<his-search-form configFile="fs/res/searchPatent.xml"></his-search-form>
</div>
